// extracted by mini-css-extract-plugin
export default {"container":"yde4Br","domainEllipsisContainer":"tcRBAE","inherit":"LBL8dG"};